import classNames from 'classnames';
import type { FC, MouseEventHandler, Ref } from 'react';
import { Icon } from '../Icon/Icon';
import {
  type InteractiveAtomSize,
  fromInteractiveAtomToIconSize,
} from '../utils/InteractiveAtomProps';

type ClosePlainButtonSize = InteractiveAtomSize;
const fromClosePlainButtonToIconSize = fromInteractiveAtomToIconSize;

type ClosePlainButtonProps = {
  className?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: MouseEventHandler<HTMLButtonElement>;
  buttonRef?: Ref<HTMLButtonElement>;
  size?: ClosePlainButtonSize;
};

export const ClosePlainButton: FC<ClosePlainButtonProps> = ({
  size = 'default',
  className,
  buttonRef,
  disabled,
  onClick,
  onMouseDown,
  ...otherProps
}) => (
  <button
    {...otherProps}
    className={classNames(
      'text-default bg-transparent',
      disabled ? 'text-status-disabled-dark' : 'hover:text-status-error',
      className,
    )}
    type='button'
    disabled={disabled}
    // prevent focusing input button instead of jumping to next input on tab
    tabIndex={-1}
    ref={buttonRef}
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(e);
    }}
    onMouseDown={(e) => {
      e.stopPropagation();
      onMouseDown?.(e);
    }}
  >
    <Icon glyph='fa-xmark' size={fromClosePlainButtonToIconSize[size]} />
  </button>
);
